import base from './binance/index';
export default Object.assign({}, base);
